import { useReducer } from 'react';

const initialState = {
    position: null,
    isVisible: false,
    value: ''
};

const textToolReducer = (state, action) => {
    switch (action.type) {
        case 'SHOW':
            return { 
                ...state, 
                isVisible: true, 
                position: action.payload,
                value: '' 
            };
        case 'HIDE':
            return { 
                ...state, 
                isVisible: false, 
                position: null,
                value: '' 
            };
        case 'UPDATE_VALUE':
            return { ...state, value: action.payload };
        case 'RESET':
            return initialState;
        default:
            return state;
    }
};

export const useTextTool = () => {
    const [state, dispatch] = useReducer(textToolReducer, initialState);

    const actions = {
        show: (position) => dispatch({ type: 'SHOW', payload: position }),
        hide: () => dispatch({ type: 'HIDE' }),
        updateValue: (value) => dispatch({ type: 'UPDATE_VALUE', payload: value }),
        reset: () => dispatch({ type: 'RESET' })
    };

    return [state, actions];
};
